/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-header/VOD/content-control-studio-vod-header.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.1);
  border-width: 0px 0px 1px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  align-self: stretch;
  flex-shrink: 0;
  height: 7vh;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
.titlebar {
  height: 100%;
  flex: 0 0 25%;
  padding: 0px 0px 0px 25px;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.titlebar .media-name {
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  position: relative;
}
.timers {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.timers .timer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-family: "Open Sans";
  font-style: normal;
  line-height: 30px;
  font-size: 1.5rem;
}
.timers .timer .time {
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.timers .timer .name {
  color: rgb(114, 125, 139);
}
.buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  flex-shrink: 0;
  height: 100%;
}
.buttons .history-buttons {
  padding: 0px 25px 0px 25px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.buttons .history-buttons > div {
  border-radius: 4px;
  border-style: solid;
  cursor: pointer;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 7px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.buttons .history-buttons > div svg {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  position: relative;
}
.buttons .history-buttons > div .undo svg {
  transform: translate(-24px, 0px);
}
.buttons .history-buttons > div:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.buttons .history-buttons > div.active {
  background-color: rgba(0, 0, 0, 0.12);
}
.buttons .divider {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  position: relative;
  transform: translate(-0.5px, -0.5px);
  fill: rgba(0, 0, 0, 0.1);
}
.buttons .action-buttons {
  padding: 0px 10px 0px 25px;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.buttons .action-buttons .clear-button {
  border-radius: 4px;
  cursor: pointer;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.buttons .action-buttons .clear-button .transparent-outlined {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
.buttons .action-buttons .save-buttons {
  padding: 0px 25px 0px 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.buttons .action-buttons .save-buttons > div {
  cursor: pointer;
  background: rgb(45, 187, 252);
  border-radius: 4px;
  padding: 9px 16px 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.buttons .action-buttons .save-buttons > div .fill-outlined {
  color: rgb(255, 255, 255);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
/*# sourceMappingURL=content-control-studio-vod-header.component.css.map */
